// config.js
// const BASE_URL = 'http://localhost:5000';
const BASE_URL='http://3.110.127.48:5000'

export default BASE_URL;
